export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-cover-564aa35adfee9d40264b9ddeca05742a.png";